import React from "react";

import { signout } from "../../requests/auth";

export default class Signout extends React.Component {
  componentDidMount() {
    signout((result) => {
      if (result.success === true) {
        document.location.href = "signin";
      }
    });
  }

  render() {
    return null;
  }
}
